import { createRouter, createWebHistory } from 'vue-router';
import krRouter from './krRouter';
import enRouter from './enRouter';

const routes = [
    {
        path: '',
        component: () => import('../views/kr/main/MainView.vue'),
        beforeEnter: (to, from, next) => {
            if (window.location.pathname == '/') {
                window.location.pathname = '/kr/index.do';
            } else {
                return next();
            }
        }
    },
    ...krRouter,
    ...enRouter,
    {
        path: '/:pathMatch(.*)*',
        name: 'error',
        component: () => import('../views/kr/error/Error.vue'),
        alias: [
            '/web/www/home',
        ]
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
